import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import MindsetsJsSDK from "mindsets-js-sdk";

import {LoadedInsightsDashboardAction} from "../../actions/performance_actions";
import Template from '../InsightsDashboard/Template';

import "../InsightsDashboard/insights-dashboard.scss";

export default function () {
    const params = useParams();
    const dispatch = useDispatch();

    const dashboard = useSelector(state => state.insights_dashboard);
    const me = useSelector(state => state.me);

    useEffect(() => {
        if (me) {
            MindsetsJsSDK().API.get(`insights-dashboards/demo/${params.dashboard_id}`).then(response => dispatch(LoadedInsightsDashboardAction(response.dashboard)));
        }
    }, [me]);

    if (!Object.keys(dashboard).length || dashboard.id.toString() !== params.dashboard_id.toString()) {
        return null;
    }

    return (
        <div id='insights-dashboard'>
            <Template
                dashboard_id={params.dashboard_id}
            />
        </div>
    );
}
